<template>
  <div>
    <modal-layout-top :title="title" />

    <div class="content slider-modal">
      <div class="slider-modal-fields">

        <div class="field">
          <label class="label">Namn</label>
          <input class="input" type="text" v-model="product.name" />
        </div>

        <div class="field">
          <label class="label">Produkttyp</label>
          <select v-model="product.productType" class="input">
            <option value="Rate">Taxa</option>
            <option value="Rent">Hyra</option>
          </select>
        </div>

        <div class="field">
          <label class="label">Fakturatext</label>
          <input class="input" type="text" v-model="product.invoiceText" />
        </div>

        <div class="field">
          <label class="label">Gruppera</label>
          <input id="invoice-item-group-heading" type="checkbox" v-model="product.invoiceItemGroupHeading" class="switch is-rounded">
          <label for="invoice-item-group-heading" class="label"></label>
        </div>

        <div class="field">
          <label class="label">Aggregera</label>
          <input id="aggregate-hours-to-total" type="checkbox" v-model="product.aggregateHoursToTotal" class="switch is-rounded">
          <label for="aggregate-hours-to-total" class="label"></label>
        </div>

      </div>
      <modal-layout-buttons :store-name="'users'" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ModalLayoutTop from '@/components/modals/ModalLayoutTop'
import ModalLayoutButtons from '@/components/modals/ModalLayoutButtons'

export default {
  name: 'user-modal',

  data () {
    return {
      product: { },
      isUpdate: false
    }
  },

  components: {
    ModalLayoutTop,
    ModalLayoutButtons
  },

  props: {
    productId: {
      type: Number,
      required: false
    }
  },

  computed: {
    title () {
      if (!this.isUpdate) {
        return 'Skapa ny produkt'
      } else {
        return 'Ändra ' + this.product.name
      }
    }
  },

  methods: {
    ...mapActions('products', ['update', 'create', 'getById']),
    closePanel () {
      this.$emit('closePanel')
    },
    save () {
      if (this.productId) {
        this.update(this.product).then(() => {
          this.closePanel()
        }).catch(() => {
          this.$toast('Felaktig data', 'error')
        })
      } else {
        this.create(this.product).then(() => {
          this.closePanel()
        })
      }
    }
  },

  created () {
    this.$on('emitSave', () => {
      this.save()
    })

    if (!this.productId) {
      this.isUpdate = false
      this.product.productType = 'Rate'
    } else {
      this.getById(this.productId).then((product) => {
        this.product = product
      })
      this.isUpdate = true
    }
  }
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/modals/ProductModal.vue